export const EXIST_LOCAL_STORAGE = {
  AUTHTOKEN: "AuthToken",
  REFRESH_TOKEN: "refreshToken",
  USER_DETAIL: "userDetail",
  USERNAME: "USERNAME",
  USER_ID: "userId",
  IS_KEEP_ME: "isKeepMe",
  THEME_MODE: "themeMode",
  EXPIRATION_TIME: "expiration",
  API_KEY: "apiKey",
  FULL_NAME: "fullName",
  USER_IMG: "userImg",
  ROLE: "role",
  BOND_DATA: "bondData",
  BOND_FILTER_OBJ: "bondfILTER",
  USER_TYPE: "userType",
  ISSTAYLOGIN: "isStayLogin",
  SITE_VISITOR_ID: 'siteVisitorId',
  IS_BOUNCED: 'is_bounced',
  filtersList: 'filtersList'
};
// let baseURL = "https://sqxbonds.com/";
// const loadBaseURL = () => {
//   return fetch('/config.json')
//     .then(response => response.json())
//     .then(config => {
//       baseURL = config.api?.baseURL || baseURL;
//       return baseURL;
//     })
//     .catch(error => {
//       console.error("Failed to load baseURL from config.json:", error);
//       return baseURL; // Return the default value in case of an error
//     });
// };

// export { loadBaseURL };